// Copyright (c) 2016 Deere & Company

import './breadcrumb.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';

const buildUrl = (route, url, queryParams) => route.keepQueryParams ? `${url}${queryParams}` : url;

const Breadcrumb = props => {

    const displayText = props.shouldFormat ?
        <FormattedMessage id={props.text}/> :
        props.text;

    return props.last ?
        <span className='bread-crumb'>
            {String.fromCharCode(8203)}
            {displayText}
        </span> :
        <Link
            className='bread-crumb'
            to={buildUrl(props.route, props.url, props.queryParams)}
        >
            {String.fromCharCode(8203)}
            {displayText}
        </Link>;

};

Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.propTypes = {
    last: PropTypes.bool.isRequired,
    queryParams: PropTypes.string,
    route: PropTypes.object.isRequired,
    shouldFormat: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/app/breadcrumb.js